'use strict';

/**
 * @author Maxim Seredkin
 * @param {*} $scope
 * @param {*} $routeParams
 * @param {*} $window
 * @param {*} SupportStageService
 */
export default ['$scope', '$routeParams', '$window', 'SupportStageService',
                function($scope, $routeParams, $window, SupportStageService) {
                    $scope.stages = [];
                    SupportStageService.api.get({
                                                    filters: [`'status' EQ 'ENABLED'`],
                                                    sorts: ['npp:ASC', 'name:ASC'],
                                                }, (data) => $scope.stages = data._embedded);
                }];
